import React, { useState, useEffect } from 'react';
import './App.css';
import ProjectAbout from './ProjectAbout';
import ProjectOne from './ProjectOne';
import ProjectTwo from './ProjectTwo';
import ProjectContact from './ProjectContact';
import weirdoImg from './assets/weirdo.png';
import Exhibitcoin from './Exhibitcoin';
import welcome from './assets/welcome.png';

const projects = [
  {
    title: 'ftw',
    content: <ProjectOne />,
  },
  {
    title: 'bitcoin weirdos',
    content: <ProjectTwo />,
  },
  {
    title: 'manifesto',
    content: <ProjectContact />,
  },
  {
    title: 'cool stuff',
    content: <Exhibitcoin />,
  },
  {
    title: 'about',
    content: <ProjectAbout />,
  },
];

function App() {
  const [selected, setSelected] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [displayedContent, setDisplayedContent] = useState(null);

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    // Check on initial load
    checkIfMobile();
    
    // Add event listener
    window.addEventListener('resize', checkIfMobile);
    
    // Cleanup
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  useEffect(() => {
    if (selected !== null) {
      handlePageTransition();
    } else {
      setDisplayedContent(null);
    }
  }, [selected]);

  const handlePageTransition = () => {
    if (isTransitioning) return;
    
    setIsTransitioning(true);
    
    // Fade out
    setTimeout(() => {
      // Update content after fade out
      setDisplayedContent(selected);
      
      // Fade in after a short delay
      setTimeout(() => {
        setIsTransitioning(false);
      }, 50);
    }, 300); // Match this to the CSS transition duration
  };

  const handleMenuItemClick = (idx) => {
    if (selected === idx) return;
    
    setSelected(idx);
    if (isMobile) {
      setMenuOpen(false);
    }
  };

  const handleLogoClick = () => {
    if (selected === null) return;
    
    setIsTransitioning(true);
    
    // Fade out
    setTimeout(() => {
      setSelected(null);
      setDisplayedContent(null);
      setIsTransitioning(false);
    }, 300);
  };

  return (
    <div className="portfolio-app">
      <button 
        className="mobile-menu-button" 
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle menu"
      >
        {menuOpen ? '✕' : '☰'}
      </button>
      <nav className={`sidebar ${menuOpen ? 'open' : ''}`}>
        <div className="sidebar-title">
          <img 
            src={weirdoImg} 
            alt="Weirdo" 
            style={{ 
              width: '100%', 
              maxWidth: 120, 
              display: 'relative', 
              margin: '0 auto',
              cursor: 'pointer' 
            }} 
            onClick={handleLogoClick}
          />
        </div>
        <ul className="menu">
          {projects.map((project, idx) => (
            <li
              key={project.title}
              className={selected === idx ? 'active' : ''}
              onClick={() => handleMenuItemClick(idx)}
            >
              {project.title}
            </li>
          ))}
        </ul>
        <div className="sidebar-footer">🌐</div>
      </nav>
      <main className="content">
        <div className={`page-content ${isTransitioning ? 'fade-out' : 'fade-in'}`}>
          {selected === null ? (
            <div style={{ color: '#aaa', fontSize: '1.1rem' }}>
              <img 
                src={welcome} 
                alt="Welcome" 
                style={{ 
                  position: 'fixed',
                  bottom: '20px',
                  right: '20px',
                  width: 'auto',
                  maxWidth: '250px',
                  height: 'auto',
                  zIndex: '10'
                }} 
              />
            </div>
          ) : (
            displayedContent !== null && projects[displayedContent].content
          )}
        </div>
      </main>
    </div>
  );
}

export default App;
